import getOffsetLeft from './functions/offset';

/**
 * Toggle's the submenu when the user clicks on a parent menu link item,
 * when clicking somewhere else it hides the submenu again.
 */

const megaMenuArrow = (menus) => {
  menus.forEach((item) => {
    const submenu:HTMLElement = item.querySelector('.mega-menu__submenu-inner');

    const submenuOffsetLeft = getOffsetLeft(submenu);
    const menuItemOffsetLeft = getOffsetLeft(item);
    const menuItemWidth = item.offsetWidth;

    const arrowPosLeft = menuItemOffsetLeft - submenuOffsetLeft + menuItemWidth / 2 - 20;

    item.querySelector('.mega-menu__submenu-arrow').style.setProperty('left', `${arrowPosLeft}px`);
  });
};

const megaMenuInit = () => {
  const active: string = 'opened';

  const dropdowns: NodeListOf<HTMLElement> = document.querySelectorAll(
    '.mega-menu .mega-menu__item--has-submenu',
  );

  const dropdownLinks: NodeListOf<HTMLElement> = document.querySelectorAll(
    '.mega-menu .mega-menu__item--has-submenu .mega-menu__link',
  );

  dropdownLinks.forEach((link: HTMLElement) => {
    link.addEventListener('click', (e: Event) => {
      if (window.screen.width < 1200) {
        e.preventDefault();
      }
    });
  });

  const closeDropdowns = () => {
    dropdowns.forEach((dropdown: HTMLElement) => {
      dropdown.closest('.mega-menu__item--has-submenu').classList.remove(active);
    });
  };

  dropdowns.forEach((dropdown: HTMLElement) => {
    dropdown.addEventListener('mouseover', (e: Event) => {
      e.preventDefault();

      closeDropdowns();
      dropdown.closest('.mega-menu__item--has-submenu').classList.add(active);
    });

    dropdown.addEventListener('mouseout', (e: Event) => {
      e.preventDefault();

      closeDropdowns();
    });
  });

  const mobileDropdowns: NodeListOf<HTMLElement> = document.querySelectorAll(
    '.mega-menu .mega-menu__item--has-submenu .mega-menu__submenu-close-mobile',
  );

  mobileDropdowns.forEach((dropdown: HTMLElement) => {
    dropdown.addEventListener('click', (e: Event) => {
      e.preventDefault();
    });

    dropdown.addEventListener('click', () => {
      if (dropdown.closest('.mega-menu__item--has-submenu').classList.contains(active)) {
        closeDropdowns();
      } else {
        closeDropdowns();
        dropdown.closest('.mega-menu__item--has-submenu').classList.add(active);
      }
    });
  });

  // Remove active class of all dropdown parents
  // when clicked anywhere in document
  document.addEventListener('click', () => closeDropdowns());

  const megaMenus: NodeListOf<HTMLElement> = document.querySelectorAll('.mega-menu__item--has-submenu');
  megaMenuArrow(megaMenus);
};

export default megaMenuInit;
